export enum ProfileWidgetState {
  EDIT = 'edit',
  MENU = 'menu',
  MINIMIZE = 'minimize',
}
